import type { ReactNode } from 'react';
import MgoButton from '@humanforce/mango-ui/dist/react/button/index.js';
import { asMangoElement } from './mango';

const MangoButton = asMangoElement(MgoButton);

interface ButtonProps {
  children: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'destructive';
  onClick?: () => void;
}

export const Button = ({ children, disabled, loading, type = 'button', variant = 'primary', onClick }: ButtonProps) => {
  return (
    <MangoButton disabled={disabled || loading ? true : undefined} type={type} variant={variant} onClick={onClick}>
      {loading ? 'Saving...' : children}
    </MangoButton>
  );
}
